import { HorizonSpider } from "../charts/HorizonSpider";
import { HorizonTable } from "../charts/HorizonTable";
import { Controls } from "../controls/Controls";
import { Header } from "../../../components/Header";

export const factory = (node) => {
  var component = node.getComponent();
  switch (component) {
    case "HorizonSpider":
      return <HorizonSpider />;
    case "HorizonTable":
      return <HorizonTable />;
    case "Controls":
      return <Controls />;
    case "Header":
      return (
        <Header
          title={
            <div>
              This chart depicts the VScore criteria percentiles for the{" "}
              <span style={{ color: "#7EC9E8" }}>selected ticker</span> and the{" "}
              <span style={{ color: "green" }}>top quintile (+2)</span> and{" "}
              <span style={{ color: "red" }}>bottom quintile (-2)</span>{" "}
              performing ticker-model date that best match it for the selected
              forward time horizon, looking across the many tickers and model
              dates in VecViz’s database. The V-Score criteria are listed along
              the periphery of the chart. Criteria definitions “pop up” when you
              hover over them. Each line in the chart is a quintile for the
              criteria, with the center of the chart being the 0th percentile
              and the outer rim being the 100th percentile.
            </div>
          }
          label="horizon"
        >
          <div>V-Score Criteria Closest Comparables</div>
        </Header>
      );
    default:
      return null;
  }
};

export const onRenderTabSet = (tabSetNode, refs) => {
  const typeNode = tabSetNode.getType();
  if (typeNode === "tabset") {
    const children = tabSetNode.getChildren();
    children.forEach((child) => {
      const c = child;
      const comp = c.getComponent();
      const rect = c.getRect();
      if (comp) {
        refs.componentSize.current[comp] = {
          width: rect.width,
          height: rect.height,
        };
      }
    });
  }
};

export const layoutModelChange = (model, grefs) => {
  // console.log(JSON.stringify(model.toJson()));
  // grefs.layout.current = JSON.stringify(
  //   modifyModel(model.toJson(), layoutState, setLayoutState)
  // );
  grefs.layout.current = JSON.stringify(model.toJson());
};
